import { createStore } from 'vuex'
import { homeModule } from '@/store/modules/homeModule'
import { topRatedMoviesModule } from '@/store/modules/topRatedMoviesModule'
import { latestMoviesModule } from '@/store/modules/latestMoviesModule'

export default createStore({
  state: {
    locale: localStorage.getItem('locale') || 'en',
    currentMovie: null as any
  },
  getters: {
  },
  mutations: {
    setLocale(state, locale: string) {
      state.locale = locale
      localStorage.setItem('locale', locale)
    },
    setCurrentMovie(state, movie: any) {
      state.currentMovie = movie
    }
  },
  actions: {
  },
  modules: {
    home: homeModule,
    topRated: topRatedMoviesModule,
    latestMovies: latestMoviesModule
  }
})
